<template>
  <span id="master-rate-detail">
    <i class="el-icon-search header-info-dialog-value icon-action" id="btn-master-rate-detail"
       @click="dialogVisible = true" size="mini" icon="el-icon-plus"></i>
    <el-dialog
        id="master-rate-detail-dialog"
        :visible.sync="dialogVisible"
        width="70%"
        :title="$t('daysOfService.informationTitle')"
        :close-on-click-modal="false"
        append-to-body
    >
      <el-row>
        <el-col :span="6">
          <label class="span-small-list dos-label">{{ $t('masterRates.chargeCodes.name') }}</label>
          <span class="span-small-list">{{ defaultWhenEmpty(masterRates.chargeCodeName) }}</span>
        </el-col>
        <el-col :span="6">
          <label class="span-small-list dos-label">{{ $t('masterRates.warehouses') }}</label>
          <span class="span-small-list">{{ masterRates.hasAllWarehouses ? $t('common.all') : defaultWhenEmpty(masterRates.warehouseNames) }}</span>
        </el-col>
        <el-col :span="6">
          <label class="span-small-list dos-label">{{ $t('masterRates.rate') }}</label>
          <span class="span-small-list">{{ masterRates.rate | rateFilter(masterRates.unitsOfMeasure) }}</span>
        </el-col>
      </el-row>

      <el-row>
        <el-row>
          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('masterRates.management.effectiveDate') }}</label>
            <span class="span-small-list">{{ masterRates.effectiveDate }}</span>
          </el-col>
          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('masterRates.management.expirationDate') }}</label>
            <span class="span-small-list">{{ defaultWhenEmpty(masterRates.expirationDate) }}</span>
          </el-col>
        </el-row>
      </el-row>

      <!-- Audit Row-->
      <el-row>
        <el-row>
          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('masterRates.management.createdBy') }}</label>
            <span class="span-small-list">{{ defaultWhenEmpty(masterRates.createdByUsername) }}</span>
          </el-col>
          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('masterRates.management.createdAt') }}</label>
            <span class="span-small-list">{{ defaultWhenEmpty(masterRates.auditCreationDate) }}</span>
          </el-col>
          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('masterRates.management.lastModified') }}</label>
            <span class="span-small-list">{{ defaultWhenEmpty(masterRates.auditLastUpdateByUsername) }}</span>
          </el-col>
          <el-col :span="6">
            <label class="span-small-list dos-label">{{ $t('masterRates.management.lastModifiedAt') }}</label>
            <span class="span-small-list">{{ defaultWhenEmpty(masterRates.auditLastUpdate) }}</span>
          </el-col>
        </el-row>
      </el-row>
    </el-dialog>
  </span>
</template>

<script>
import constants from '@/utils/constants';

export default {
  name: 'DetailMasterRate',
  props: {
    masterRates: {
      type: Object,
      required: true
    },
  },
  computed: {
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    getBooleanLabel(booleanValue) {
      return booleanValue ? 'Yes' : 'No';
    },
    defaultWhenEmpty(value) {
      if (value === null || value === undefined) {
        return '-';
      }

      if (Array.isArray(value)) {
        return value.length === 0 ? '-' : value.join(', ');
      }

      if (typeof value === 'string' && value.trim() === '') {
        return '-';
      }

      return value;
    },
    getDayOfServiceLabel(dayOfService) {
      if (!dayOfService) return '';
      const dayObj = constants.DAY_OF_SERVICE.DOS_TYPE.find(d => d.value === dayOfService);
      return dayObj ? dayObj.label : '';
    },
    getDayLabel(daysArray) {
      if (!Array.isArray(daysArray)) return '';
      const allDays = [1, 2, 3, 4, 5, 6, 7];
      const isAllDays = allDays.every(day => daysArray.includes(day)) && daysArray.length === allDays.length;
      if (isAllDays) {
        return 'ALL DAYS';
      }
      return daysArray
        .map(dayInt => {
          const dayObj = constants.DAY_OF_SERVICE.DAYS_OF_WEEK.find(d => d.numberValue === dayInt);
          return dayObj ? dayObj.label : '';
        })
        .filter(label => label)
        .join('; ');
    }
  }
};
</script>
